import { LisaButtonTarget } from "@/graphql";
import { hasRightOnAnySite } from "./authorizationState";

const DEFAULT_LISA_BUTTON_TARGET: LisaButtonTarget = LisaButtonTarget.PREFERRED_KPI_BOARD;

export function isLisaButtonTarget(value: unknown): value is LisaButtonTarget {
  return (
    value === LisaButtonTarget.DASHBOARD ||
    value === LisaButtonTarget.LAST_KPI_BOARD ||
    value === LisaButtonTarget.PREFERRED_KPI_BOARD ||
    value === LisaButtonTarget.LAST_EAB_BOARD ||
    value === LisaButtonTarget.PREFERRED_EAB_BOARD
  );
}

export function normalizeLisaButtonTarget(value: unknown): LisaButtonTarget {
  return isLisaButtonTarget(value) ? value : DEFAULT_LISA_BUTTON_TARGET;
}

export function resolveLisaButtonRoute(
  target: LisaButtonTarget,
  startUpBoardId?: number | null,
): string {
  if (target === LisaButtonTarget.DASHBOARD || !hasRightOnAnySite("sqdc.read")) {
    return "/dashboard";
  }

  if (target === LisaButtonTarget.LAST_KPI_BOARD) {
    return "/sqdcBoard/kpi";
  }

  if (target === LisaButtonTarget.LAST_EAB_BOARD) {
    return "/sqdcBoard/eab";
  }

  if (startUpBoardId != null && !Number.isNaN(startUpBoardId)) {
    if (target === LisaButtonTarget.PREFERRED_EAB_BOARD) {
      return `/sqdcBoard/eab/${startUpBoardId}`;
    }
    return `/sqdcBoard/kpi/${startUpBoardId}`;
  }

  if (target === LisaButtonTarget.PREFERRED_EAB_BOARD) {
    return "/sqdcBoard/eab";
  }

  return "/sqdcBoard/kpi";
}
